import {
  SiSpotify,
  SiMeta,
  SiShopify,
  SiNotion,
  SiFigma,
  SiWordpress,
  SiX,
  SiGrammarly,
  SiKhanacademy,
  SiCoursera,
  SiEvernote,
  SiDuolingo,
  SiNetflix,
  SiCanvas,
  SiInstagram,
  SiZoom,
} from "react-icons/si";
import {
  FaYoutube,
  FaGoogle,
  FaChrome,
  FaWhatsapp,
  FaTiktok,
  FaAmazon,
  FaMicrosoft,
  FaSlack,
  FaDiscord,
  FaTelegram,
  FaUber,
  FaLinkedin,
  FaPinterest,
  FaReddit,
  FaDropbox,
  FaStrava,
  FaGithub,
  FaAirbnb,
  FaApple,
  FaFacebook,
} from "react-icons/fa";

const BRAND_ICONS: Record<string, React.ComponentType<{ className?: string }> | string> = {
  Spotify: SiSpotify,
  YouTube: FaYoutube,
  "Google Chrome": FaChrome,
  Zoom: SiZoom,
  WhatsApp: FaWhatsapp,
  "WhatsApp Business": FaWhatsapp,
  "X (Twitter)": SiX,
  TikTok: FaTiktok,
  Netflix: SiNetflix,
  Amazon: FaAmazon,
  "Microsoft Teams": FaMicrosoft,
  Slack: FaSlack,
  Discord: FaDiscord,
  Telegram: FaTelegram,
  Uber: FaUber,
  LinkedIn: FaLinkedin,
  Pinterest: FaPinterest,
  Reddit: FaReddit,
  Dropbox: FaDropbox,
  Strava: FaStrava,
  GitHub: FaGithub,
  Airbnb: FaAirbnb,
  "Google Search": FaGoogle,
  Facebook: FaFacebook,
  "Facebook Lite": FaFacebook,
  Shopify: SiShopify,
  Notion: SiNotion,
  Figma: SiFigma,
  "Microsoft 365": FaMicrosoft,
  WordPress: SiWordpress,
  Evernote: SiEvernote,
  Grammarly: SiGrammarly,
  "Khan Academy": SiKhanacademy,
  Coursera: SiCoursera,
  "Apple Music": FaApple,
  "Google Workspace": FaGoogle,
  Chrome: FaChrome,
  Duolingo: SiDuolingo,
  Canva: SiCanvas,
  Instagram: SiInstagram,
  "VS Code": "/brand-icons/vscode.png",
  "Adobe Lightroom": "/brand-icons/lightroom.png",
};

export function getAppIcon(
  appName: string,
): React.ComponentType<{ className?: string }> | string | null {
  return BRAND_ICONS[appName] || null;
}
